export const ReceiptIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9997 3.33073L18.6663 2.66406L17.333 3.33073L15.9997 2.66406L14.6663 3.33073L13.333 2.66406L11.9997 3.33073L10.6663 2.66406L9.33301 3.33073L7.33301 2.66406V13.3307V13.3328H16.6663V18.9974C16.6663 20.2861 18.0443 21.3307 19.333 21.3307H19.833C21.1218 21.3307 21.9997 20.2861 21.9997 18.9974V2.66406L19.9997 3.33073ZM12.6872 11.3307L12.6663 9.9974H19.3122L19.333 11.3307H12.6872ZM10.0205 7.9974L9.99967 6.66406H19.3122L19.333 7.9974H10.0205Z"
      fill="#6B717D"
    />
    <path
      d="M15.3333 18.9974V14.6641H2V15.9974C2 18.1036 2.24083 18.9816 2.6025 19.6486C3.21625 20.7807 4.3275 21.3307 6 21.3307H16.6667C16.6667 21.3307 15.3333 20.4974 15.3333 18.9974Z"
      fill="#6B717D"
    />
  </svg>
);
